
export default function ConsultingSection() {
  const features = [
    {
      icon: 'ri-compass-3-line',
      title: '目的から逆算した設計',
      description: '見た目ではなく、問い合わせにつながる構造を設計します。'
    },
    {
      icon: 'ri-robot-line',
      title: 'AI＋人の判断',
      description: 'AIは効率化に活用。最終判断は必ず人が行います。'
    },
    {
      icon: 'ri-server-line',
      title: 'サーバー・WordPressの理解',
      description: 'ログインやドメインのトラブルにも対応できます。'
    },
    {
      icon: 'ri-tools-line',
      title: '納品後も使えるサイト',
      description: 'お客様が自分で更新できる構造を構築します。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* AI時代でも選ばれる理由 */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-navy mb-4">
            AI時代でも選ばれる理由
          </h2>
        </div>

        {/* AIで作るだけでは成果は出ません */}
        <div className="mb-20 bg-gradient-to-br from-accent-light to-accent rounded-2xl p-10 lg:p-16">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-navy mb-8 text-center">
              AIでは、成果は設計できません。
            </h3>
            
            <p className="text-lg text-gray-700 mb-8 text-center leading-relaxed">
              最近はAIで簡単にサイトが作れる時代です。<br />
              しかし、成果を出すには設計が必要です。
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-10">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-cta text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-navy mb-1">誰に届けるのか</h4>
                    <p className="text-sm text-gray-600">ターゲットを明確にした設計</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-cta text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-navy mb-1">どんな導線で問い合わせにつなげるのか</h4>
                    <p className="text-sm text-gray-600">成果につながる動線設計</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-cta text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-navy mb-1">更新しやすい構造か</h4>
                    <p className="text-sm text-gray-600">運用を見据えた設計</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-cta text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-navy mb-1">トラブル時に対応できるか</h4>
                    <p className="text-sm text-gray-600">安心のサポート体制</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center bg-white rounded-xl p-6 shadow-sm">
              <div className="mb-4">
                <div className="flex flex-col items-center gap-3 mb-4">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-cta text-lg"></i>
                    <span className="text-sm font-semibold text-navy">構成設計</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-cta text-lg"></i>
                    <span className="text-sm font-semibold text-navy">営業導線</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-cta text-lg"></i>
                    <span className="text-sm font-semibold text-navy">ターゲット心理</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-cta text-lg"></i>
                    <span className="text-sm font-semibold text-navy">問い合わせ動線</span>
                  </div>
                </div>
                <p className="text-base text-gray-700 mb-4">
                  これらはAIが自動で理解するものではありません。
                </p>
              </div>
              <p className="text-base text-gray-700 mb-2">
                私たちはAIを活用する場合もあります。
              </p>
              <p className="text-xl font-bold text-cta">
                しかし、判断するのは人です。
              </p>
            </div>
          </div>
        </div>

        {/* 私たちの制作の特徴 */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-navy mb-4">
            私たちの制作の特徴
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100"
            >
              <div className="w-16 h-16 bg-accent rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-navy-light`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
